import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5052de2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quant-page" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarTabBar = _resolveComponent("StarTabBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StarTabBar, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("iframe", {
      class: "quant-iframe",
      src: _ctx.iframeUrl,
      frameborder: "0",
      allowfullscreen: ""
    }, null, 8, _hoisted_2)
  ]))
}